import { Component, OnInit, ViewEncapsulation, output, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgClass } from '@angular/common';

import { AvailableIcons, ApIconComponent } from '@ap/icon';
import { ApPopoverComponent } from '@ap/popover';
import '@asn/badge';

import { NavigationItem, NavigationType } from '../../header.model';

@Component({
    selector: 'ap-horizontal-menu-popover',
    templateUrl: './horizontal-menu-popover.component.html',
    styleUrls: ['./horizontal-menu-popover.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApPopoverComponent, ApIconComponent, NgClass],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApHorizontalMenuPopoverComponent implements OnInit {
    /**
     * Required - The navigation items
     */
    public readonly navigationItem = input.required<NavigationItem>();

    /**
     * Indicates whether it is the last item, which changes the styling a bit
     */
    public readonly lastItem = input(false);

    /**
     * Indicates whether it is the last item, which changes the styling a bit
     */
    public readonly navigationClicked = output<NavigationItem>();

    public navigationType = NavigationType;

    // Temporary fix. Remove A19
    ngOnInit() {
        const navigationItem = this.navigationItem();
        if (navigationItem.iconName !== null) {
            navigationItem.iconName = navigationItem.label as AvailableIcons;
        }
    }

    onIsOpenChanged(isOpen: boolean) {
        this.navigationItem().isOpen = isOpen;
    }
}
